import type { VirtualNodeProps } from '@gitbook/slate-react';

export function VirtualBlockOpenAPI(props: VirtualNodeProps) {
    return (
        <div ref={props.domRef} {...props.attributes} style={props.style} className="block-openapi">
            {props.children}
        </div>
    );
}
